import React, { useState } from 'react';
import '../stylesheets/node-widget.css';
import BotNode from './bot-node';
import {Text} from "../../../../components/Text/index"
const NodeWidget = (props) => {

    const { title, nodesList, handleClick } = props;

    const [expandView, setExpandView] = useState(false);

    const handleExpandClick = ()  => {
      setExpandView(prev => !prev);
    }

  return <div className='node-widget-container'>
    <div className='flex justify-content-between align-items-center w-full p-2'>
        <Text type={"sub-heading"}>{title}</Text>
        
        <button className='border-0 cursor-pointer exp-btn' onClick={handleExpandClick}>{expandView ? <i className='pi pi-angle-down' /> :<i className='pi pi-angle-up' /> }</button>
    </div>
    <div className={`btnode-list-cont p-2 ${expandView && 'btnode-list-cont-hide'}`}>{
        nodesList?.map((node, index) => (
            <BotNode key={index} nodeData={node} handleClick={handleClick}/>
        ))
        }</div>
  </div>;
}

export default NodeWidget;